import { render, staticRenderFns } from "./qpe_dialog_history.vue?vue&type=template&id=54187a52&scoped=true&"
import script from "./qpe_dialog_history.vue?vue&type=script&lang=js&"
export * from "./qpe_dialog_history.vue?vue&type=script&lang=js&"
import style0 from "./qpe_dialog_history.vue?vue&type=style&index=0&id=54187a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54187a52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54187a52', component.options)
    } else {
      api.reload('54187a52', component.options)
    }
    module.hot.accept("./qpe_dialog_history.vue?vue&type=template&id=54187a52&scoped=true&", function () {
      api.rerender('54187a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/qpe_dialog_history.vue"
export default component.exports